//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CooperativeMachines from "./components/CooperativeMachines";
import CooperativeCirculationInfo from "./components/CooperativeCirculationInfo";
import { mapState, mapActions } from "vuex";
export default {
  name: "BasicInfoHome",
  components: {
    CooperativeMachines,
    CooperativeCirculationInfo,
  },
  data() {
    return {
      isRequest: false,
      detail: {},
      honorList: [],
      activeName: "first",
      activeNameLeft: "first",
      activeNameRight: "first",
      masterId: "",
    };
  },
  filters: {
    formatCropCodeNameList: function (value) {
      if (value) {
        return value.join("，");
      } else {
        return "";
      }
    },
  },
  computed: {
    businessLicenseUrl() {
      return this.detail.businessLicenseUrl || "";
    },
    businessLicenseUrlList() {
      let pics = [];
      if (this.detail.businessLicenseUrl) {
        pics = this.detail.businessLicenseUrl.split(",");
      }
      return pics;
    },
    headUrl() {
      return this.detail.directorDto && this.detail.directorDto.headUrl
        ? this.detail.directorDto.headUrl
        : "";
    },
    headUrlList() {
      let pics = [];
      if (this.detail.directorDto && this.detail.directorDto.headUrl) {
        pics = this.detail.directorDto.headUrl.split(",");
      }
      return pics;
    },
    honorPreviewList() {
      let cooFileDtoList = this.detail.cooFileDtoList,
        tempAry = [];
      if (cooFileDtoList && cooFileDtoList.length > 0) {
        this.detail.cooFileDtoList.forEach((item) => {
          tempAry.push(item.picPath);
        });
      }
      return tempAry;
    },
  },
  created() {
    let { $businessAccountId } = this.$route.query;
    this.masterId = $businessAccountId;
    this.queryCoosByMasterId(this.masterId);
  },
  methods: {
    /**
     * @descripttion: 获取合作社基本信息
     * @Author: juanjuanhui
     * @Date: 2021-11-22 10:19:54
     * @param {*}
     */
    queryCoosByMasterId(accountId) {
      this.$http.basicInfo.queryCoosByMasterId({ accountId }).then((res) => {
        let { cooFileDtoList } = res.data;
        res.data.cropCodeNameList = res.data.cropCodeNameList
          ? res.data.cropCodeNameList
          : [];
        this.detail = res.data;
        this.isRequest = true;
        if (cooFileDtoList && cooFileDtoList.length > 0) {
          this.honorList = this.detail.cooFileDtoList.filter((item) => {
            return item.fileType == 2;
          });
          this.honorList = this.honorList.slice(0, 4);
        }
      });
    },
  },
};
